module.exports = __webpack_public_path__ + "img/do_not_copy_eir_copy.56017cfb.png";